import { useEffect, useState } from "react";
import { fetchLeads } from "../../lib/leadsApi";

export default function AdminLeadsPage() {
  const [leads, setLeads] = useState(null);

  useEffect(() => {
    fetchLeads().then(({ data }) => setLeads(data ?? []));
  }, []);

  return (
    <div>
      <h1 className="mb-6 text-2xl font-bold text-zinc-900">Leads</h1>

      {leads === null ? (
        <p className="text-zinc-600">Loading…</p>
      ) : !leads.length ? (
        <p className="text-zinc-600">No submissions yet.</p>
      ) : (
        <>
          <div className="hidden overflow-x-auto rounded-lg border border-zinc-200 bg-white sm:block">
            <table className="w-full text-left text-sm">
              <thead className="bg-zinc-50 text-zinc-500">
                <tr>
                  <th className="px-4 py-3">Name</th>
                  <th className="px-4 py-3">Email</th>
                  <th className="px-4 py-3">Phone</th>
                  <th className="px-4 py-3">Book</th>
                  <th className="px-4 py-3">Emailed</th>
                  <th className="px-4 py-3">Date</th>
                </tr>
              </thead>
              <tbody>
                {leads.map((lead) => (
                  <tr key={lead.id} className="border-t border-zinc-100">
                    <td className="px-4 py-3 font-medium text-zinc-900">
                      {lead.first_name} {lead.last_name}
                    </td>
                    <td className="px-4 py-3">{lead.email}</td>
                    <td className="px-4 py-3">{lead.phone}</td>
                    <td className="px-4 py-3">{lead.book_slug}</td>
                    <td className="px-4 py-3">{lead.emailed ? "Yes" : "No"}</td>
                    <td className="px-4 py-3 text-zinc-500">
                      {new Date(lead.created_at).toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="space-y-3 sm:hidden">
            {leads.map((lead) => (
              <div
                key={lead.id}
                className="rounded-lg border border-zinc-200 bg-white p-4 shadow-sm"
              >
                <p className="font-semibold text-zinc-900">
                  {lead.first_name} {lead.last_name}
                </p>
                <p className="text-sm text-zinc-600">{lead.email}</p>
                <p className="text-sm text-zinc-600">{lead.phone}</p>
                <p className="mt-2 text-xs text-zinc-400">
                  {lead.book_slug} · {lead.emailed ? "Emailed" : "Not emailed"}
                </p>
                <p className="text-xs text-zinc-400">
                  {new Date(lead.created_at).toLocaleString()}
                </p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
